import { Bootgrid } from './bootgrid';
import { BootgridChangeType } from './bootgridTypes';
import { BootgridKeyboardShortcutManager } from './BootgridKeyboardShortcutManager';

export class BootgridManager {
    bootgrids: Bootgrid[];
    
    constructor(bootgrids: Bootgrid[]) {
        this.bootgrids = bootgrids;
        new BootgridKeyboardShortcutManager(bootgrids);
    }

    getPostValueChangeFormData(bootgrid: Bootgrid, changedRows: object[], changeType: BootgridChangeType, gridObject?: any, changedPropertyName?: string): FormData {
        const additionalData = new FormData();
        if (changeType === BootgridChangeType.search) {
            if (gridObject === undefined) {
                throw new Error('Bootgrid should be defined when changeType is search');
            }
            const additionalData = new FormData();
            const propertyName = bootgrid.$bootgrid.attr('data-luscinia-field-name');
            const keyColumnName = bootgrid.$bootgrid.attr('data-luscinia-keycolumnname');
            additionalData.append(propertyName + '-selectedrows', this.getSelectedRowsString(bootgrid));
            additionalData.append(propertyName + '-displayedrows', this.getDisplayedRowsString(bootgrid));
            additionalData.append(propertyName + '-aftervaluechanged-changetype', BootgridChangeType.search);
            const currentRowIds: string[] = gridObject.currentRows.map((obj) => obj[keyColumnName]);
            const selectedRowIds: string[] = gridObject.selectedRows;

            if (bootgrid.previousRows === undefined) {
                bootgrid.previousRows = currentRowIds;
            }

            const unselectedRows = selectedRowIds.filter((rowId) => !currentRowIds.includes(rowId));
            if (unselectedRows.length > 0) {
                additionalData.append(propertyName + '-aftervaluechanged-deselectedrows', unselectedRows.join(','));
            }
            const newSelectedRows = currentRowIds.filter((rowId) => !bootgrid.previousRows.includes(rowId)).filter((rowId) => selectedRowIds.includes(rowId));
            if (newSelectedRows.length > 0) {
                additionalData.append(propertyName + '-aftervaluechanged-selectedrows', newSelectedRows.join(','));
            }

            bootgrid.previousRows = currentRowIds;
            if (unselectedRows.length > 0 || newSelectedRows.length > 0) {
                const otherBootgrids = bootgrid.bootgridManager.bootgrids.filter((b) => b.id !== bootgrid.id);
                otherBootgrids.forEach((bootgrid) => {
                    const bootgridPropertyName = bootgrid.$bootgrid.attr('data-luscinia-field-name');
                    additionalData.append(bootgridPropertyName + '-selectedrows', this.getSelectedRowsString(bootgrid));
                    additionalData.append(bootgridPropertyName + '-displayedrows', this.getDisplayedRowsString(bootgrid));
                });
            }
            return additionalData;
        }
        if (changeType === BootgridChangeType.select || changeType === BootgridChangeType.deselect) {
            const propertyName = bootgrid.$bootgrid.attr('data-luscinia-field-name');
            const keyColumnName = bootgrid.$bootgrid.attr('data-luscinia-keycolumnname');
            additionalData.append(propertyName + '-selectedrows', this.getSelectedRowsString(bootgrid));
            additionalData.append(propertyName + '-displayedrows', this.getDisplayedRowsString(bootgrid));
            additionalData.append(propertyName + '-aftervaluechanged-changetype', changeType);
            additionalData.append(propertyName + `-aftervaluechanged-${changeType === BootgridChangeType.select ? 'selectedrows' : 'deselectedrows'}`, changedRows.map((obj) => obj[keyColumnName]).join(','));

            const otherBootgrids = bootgrid.bootgridManager.bootgrids.filter((b) => b.id !== bootgrid.id);
            otherBootgrids.forEach((bootgrid) => {
                const bootgridPropertyName = bootgrid.$bootgrid.attr('data-luscinia-field-name');
                additionalData.append(bootgridPropertyName + '-selectedrows', this.getSelectedRowsString(bootgrid));
                additionalData.append(bootgridPropertyName + '-displayedrows', this.getDisplayedRowsString(bootgrid));
            });
            return additionalData;
        }

        if (changeType === BootgridChangeType.update) {
            const propertyName = bootgrid.$bootgrid.attr('data-luscinia-field-name');
            const keyColumnName = bootgrid.$bootgrid.attr('data-luscinia-keycolumnname');
            const changedRow = changedRows[0];
            additionalData.append(propertyName + '-aftervaluechanged-rowid', changedRow[keyColumnName]);
            additionalData.append(propertyName + '-aftervaluechanged-propertyname', changedPropertyName);
            additionalData.append(propertyName + '-aftervaluechanged-propertyvalue', changedRow[changedPropertyName]);
            additionalData.append(propertyName + '-selectedrows', this.getSelectedRowsString(bootgrid));
            additionalData.append(propertyName + '-displayedrows', this.getDisplayedRowsString(bootgrid));
            additionalData.append(propertyName + '-aftervaluechanged-changetype', changeType);
            return additionalData;
        }
        return null;
    }
    private getSelectedRowsString(bootgrid: Bootgrid): string {
        const selectedRowIds: string[] = (bootgrid.$bootgrid as any).bootgrid('getSelectedRowIds') as string[];
        return selectedRowIds.join(',');
    }
    private getDisplayedRowsString(bootgrid: Bootgrid): string {
        return (bootgrid.$bootgrid as any).bootgrid('getSelectedRowIds');
    }
}
